import { ProductItemSchema } from "@/schemas/product/product-item";
import { ProductImageItemSchema } from "@/schemas/product/product-image-item";
import { z } from "zod";

export const ShippingItemSchema = z.object({
  Id: z.string(),
  DeliveryStatus: z.string().optional(),
  ShippingAddress: z.string().optional(),
  TrackingNumber: z.string(),
  ProductId: ProductItemSchema.shape.Id.optional(),
  ProductImage: ProductImageItemSchema.shape.ThumbnailUrl.optional(),
  ProductName: ProductItemSchema.shape.Name.optional(),
  State: z.number().optional(),
});

export type ShippingItemType = z.infer<typeof ShippingItemSchema>;
